<div class="row" style="padding-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<div class="container" >
  <div class="row">
    <div class="col-md-4 pull-right hidden-xs hidden-sm" style="float: left !important;">
      <div class="yCmsContentSlot login-right-content-slot">
        <div class="yCmsComponent login-right-content-component">
          <div class="banner__component simple-banner">
            <a style="display: block;">
              <img class="img-fluid" style="margin-top:38px" title="login image" alt="login image"
                src="assets/img/bg.png" />
            </a>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-8" style="margin-top: 38px;" onload="document.location='https://buyer.sukandaonelink.com/aktivasi'">
      <div class="yCmsContentSlot regist-left-content-slot js-regist-slot"
        style="margin-right: 10px; display: flex; flex-direction: column;">
        <div class="yCmsComponent regist-left-content-component" style="order: 2;">
          <div class="regist-section">
            <div>
              <div>
                <div>
                  <h3 class="register-customer txt-registrasi">
                    Registrasi
                  </h3>
                </div>
                  <p class="txt-register2" style="display:none">
                    Silahkan lengkapi data berikut untuk aktivasi akun Sukanda
                    Onelink Anda
                  </p>

                  <p class="txt-register2">
                    Silahkan klik tombol berikut untuk aktivasi akun Sukanda
                    Onelink Anda
                  </p>
                  <button class="btn btn-sol" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">Aktifasi
                  </button>
                <div class="row" style="display:none">
                  <div class="col-8">

                    <div class="form-group inline">
                      <p class="txt-register22">
                        Apakah Anda sudah terdaftar sebagai
                        <i>customer</i> Sukanda Djaya?
                      </p>

                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <label class="radio-inline" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">
                        <input type="radio" name="existing" value="sudah" checked [(ngModel)]="existing" style="
                            width: 20px;
                            height: 20px;
                            margin-right: 10px;
                            margin-left: 10px;
                          " />
                        <p style="margin-top: -22px;
                        margin-left: 42px;">Sudah</p>
                      </label>
                      <label class="radio-inline" onclick="document.location='https://buyer.sukandaonelink.com/aktivasi'">
                        <input type="radio" name="existing" value="belum" [(ngModel)]="existing" style="
                            width: 20px;
                            height: 20px;
                            margin-right: 10px;
                            margin-left: 10px;
                          " />
                        <p style="margin-top: -22px;margin-left:42px">Belum</p>
                      </label>
                    </div>
                  </div>

                  <div style="margin-left: 305px; margin-top: -55px;">

                  </div>


                  <div *ngIf="existing ==='sudah'">
                    <div>
                      <form class="registerCustomerForm" [formGroup]="registerCustomerForm"
                        (ngSubmit)=" onSubmit(registerCustomerForm.value)">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">
                                <input id="outletName" name="outletName" formControlName="outletName"
                                  class="form-control form-control-style" placeholder="Nama Usaha" type="text" />

                                <div *ngIf="isSubmitted && f.outletName.invalid" class="invalid">
                                  <div *ngIf="f.outletName.errors.required">
                                    &#65121; Nama Usaha harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">
                                <input id="picName" name="picName" formControlName="picName"
                                  class="form-control form-control-style" placeholder="Nama PIC" type="text" />
                                <div *ngIf="isSubmitted && f.picName.invalid" class="invalid">
                                  <div *ngIf="f.picName.errors.required">
                                    &#65121; Nama PIC harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">
                                <input id="picEmail" name="picEmail" formControlName="picEmail"
                                  class="form-control form-control-style" placeholder="Alamat Email" type="email" />
                                <div *ngIf="isSubmitted && f.picEmail.invalid" class="invalid">
                                  <div *ngIf="f.picEmail.errors.required">
                                    &#65121; Alamat Email harus diisi.
                                  </div>
                                  <div *ngIf="f.picEmail.errors.email">
                                    &#65121; Email harus sesuai format contoh:
                                    example@mail.com.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">
                                <input id="picPhoneNumber" name="picPhoneNumber" formControlName="picPhoneNumber"
                                  class="form-control form-control-style" placeholder="Nomer Telepon" type="text" />
                                <div *ngIf="f.picPhoneNumber.touched && f.picPhoneNumber.invalid" class="invalid">
                                  <div *ngIf="f.picPhoneNumber.errors.required">
                                    &#65121; Nomer HP PIC harus diisi
                                  </div>
                                  <div *ngIf="f.picPhoneNumber.errors.pattern">
                                    &#65121; Nomer HP harus diisi angka.
                                  </div>
                                  <div *ngIf="f.picPhoneNumber.errors?.minlength">
                                    &#65121; Min 10 Karakter.
                                  </div>
                                  <div *ngIf="f.picPhoneNumber.errors?.maxlength">
                                    &#65121; Max 15 Karakter.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">

                                <select formControlName="outletBranch" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;
                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="outletBranch" id="outletBranch" >
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Lokasi Outlet Terdaftar</option>
                                  <option *ngFor="let b of outletCity" [value]="b.id" [ngValue]="b.id">
                                    &nbsp;&nbsp;{{b.name.replace('SKD','')}}
                                  </option>
                                </select><!--(change)="onChangeCity($event.target.value)"-->
                               <div *ngIf="isSubmitted && f.outletBranch.invalid" class="invalid">
                                  <div
                                    *ngIf="f.outletBranch.errors.required && f.outletBranch.touched && f.outletBranch.invalid">
                                    &#65121; Cabang harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6" style="display:none">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container form-input-container1">
                                <input id="emailSalesman" name="emailSalesman" formControlName="emailSalesman"
                                  class="form-control form-control-style" type="text"  value="maria.stacia@diamond.co.id"/>

                                <!--<select formControlName="emailSalesman" name="emailSalesman" id="emailSalesman" required>
                                  <option value="maria.stacia@diamond.co.id" selected>Tidak Tahu</option>
                                </select>-->
                                <!--<select formControlName="emailSalesman" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    text-transform: uppercase;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="emailSalesman" id="emailSalesman" #msg required
                                  (change)="emailSalesman.id = $event.target.value;
                                  filterSales($event)">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Nama PIC Sales</option>
                                  <option value="cssukanda13@diamond.co.id" style="color: grey !important; font-weight: bold;">&nbsp;&nbsp;TIDAK TAHU</option>
                                  <option *ngFor="let s of emailSalesman;" [value]="s.id" [ngValue]="s.id">
                                    &nbsp;&nbsp;{{s.name}}</option>
                                </select>

                                <div *ngIf="isSubmitted && f.emailSalesman.invalid" class="invalid">
                                  <div
                                    *ngIf="f.emailSalesman.errors.required && f.emailSalesman.touched && f.emailSalesman.invalid">
                                    &#65121; Salesman harus diisi.
                                  </div>
                                </div>-->

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <p class="tx-medium" style="
                                font-size: 12px;
                                color: #737b7d;
                                line-height: 1.42857143;
                                margin-bottom: none;
                                box-sizing: border-box;

                              ">
                              Dengan melanjutkan ke langkah berikutnya, Anda
                              menyetujui semua
                              <a class="terms-and-conditions-link" [routerLink]="['/syarat&ketentuan']" style="
                                  color: #3c64b1;
                                  text-decoration: none;

                                ">syarat &amp; ketentuan</a>
                              serta
                              <a class="terms-and-conditions-link" [routerLink]="['/kebijakan-privasi']" style="
                                  color: #3c64b1;
                                  text-decoration: none;

                                ">kebijakan privasi</a>
                              yang berlaku.
                            </p>
                          </div>
                          <div class="col-sm-6">
                            <div *ngIf="buttonSubmit">
                              <button type="submit" style="
                                  color: #fff;
                                  background-color: #3c64b1;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #3c64b1;

                                  /* Elevasi 3 */
                                  box-shadow: 4px 8px 24px rgba(0, 0, 0, 0.1);
                                  border-radius: 4px;
                                " [disabled]="registerCustomerForm.invalid"
                                class="btn btn-block contained js-regist-check-2fa-flag">
                                Daftar Sekarang
                              </button>
                            </div>
                            <div *ngIf="buttonLoading">
                              <button class="btn btn-primary" disabled>
                                <span class="spinner-border spinner-border-sm"></span>
                                Loading..
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="row" style="
                            width: 708px;
                            border-top: 1px solid #e8e8e8;
                            margin-left: 0px;
                          ">
                          <h6 style="margin-top: 26px;">
                            <p style="
                                position: absolute;
                                width: auto;
                                height: 24px;

                                font-style: normal;
                                font-weight: bold;
                                font-size: 18px;
                                line-height: 24px;
                                margin-left: -10px;
                                /* identical to box height, or 133% */
                                letter-spacing: 0.1px;

                                /* Light / Black */
                                color: #373f41;
                              ">
                              Sudah punya akun? Silahkan
                              <a class="terms-and-conditions-link"
                                href="https://idp.pepperi.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dpepperi.webapp.www.sukandaonelink.com%26redirect_uri%3Dhttps%253A%252F%252Fwww.sukandaonelink.com%252Fcallback.html%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520pepperi.webapp_api%2520pepperi.profile%2520pepperi.webapp_identity%2520pepperi.apint%26state%3D96853cac34694c198b349b260598baf4%26code_challenge%3D4dLrB1oaeKJ2grjpIm3JKUDDrcWVaug8v4NH_p9NgdY%26code_challenge_method%3DS256%26response_mode%3Dquery"
                                style="
                                  color: #3c64b1;
                                  text-decoration: none;
                                ">Login disini</a>
                            </p>
                          </h6>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div *ngIf="existing ==='belum'">
                    <div>
                      <form class="newRegisterCustomerForm" [formGroup]="newRegisterCustomerForm">
                        <div class="row" style="margin-top: 30px;">
                          <div class="col">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="tipePelanggan" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="tipePelanggan" id="tipePelanggan"
                                  (change)="onChangeTipe($event.target.value)" [(ngModel)]="tipe">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Tipe Pelanggan</option>
                                  <option style="line-height: 20px; padding-bottom:25px; font-size: 20px !important;"
                                    *ngFor="let b of tipePelanggan" [value]="b" [ngValue]="b">
                                    &nbsp;&nbsp;{{b}}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div *ngIf="existing ==='belum' && tipe !== 'Pribadi' && tipe !== 'Pemilik Bisnis'" class="row"
                    style="width: 708px; margin-left: 0px;">
                    <form>
                      <h6 style="margin-top: 26px;">
                        <p style="
                            position: absolute;
                            width: auto;
                            height: 24px;

                            font-style: normal;
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 24px;
                            margin-left: -10px;
                            /* identical to box height, or 133% */
                            letter-spacing: 0.1px;

                            /* Light / Black */
                            color: #373f41;
                          ">
                          Sudah punya akun? Silahkan
                          <a class="terms-and-conditions-link"
                            href="https://idp.pepperi.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dpepperi.webapp.www.sukandaonelink.com%26redirect_uri%3Dhttps%253A%252F%252Fwww.sukandaonelink.com%252Fcallback.html%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520pepperi.webapp_api%2520pepperi.profile%2520pepperi.webapp_identity%2520pepperi.apint%26state%3D96853cac34694c198b349b260598baf4%26code_challenge%3D4dLrB1oaeKJ2grjpIm3JKUDDrcWVaug8v4NH_p9NgdY%26code_challenge_method%3DS256%26response_mode%3Dquery"
                            style="
                              color: #3c64b1;
                              text-decoration: none;

                            ">Login disini</a>
                        </p>
                      </h6>
                    </form>
                  </div>

                  <div *ngIf="existing ==='belum' && tipe ==='Pemilik Bisnis'">
                    <div>
                      <form class="tipePelangganPemilik" [formGroup]="newRegisterCustomerForm"
                        (ngSubmit)=" onSubmitNew(newRegisterCustomerForm.value)">
                        <div class="row">
                          <div class="col">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="businessName" name="businessName" formControlName="businessName"
                                  class="form-control" placeholder="Nama Usaha" type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  " />
                                <div *ngIf="isNewSubmitted && f.businessName?.invalid" class="invalid">
                                  <div *ngIf="f.businessName?.errors.required">
                                    &#65121; Nama Usaha harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="businessCategory" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="businessCategory" id="businessCategory"
                                  (change)="onChangeBusinessCategory($event.target.value)">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Kategori Bisnis</option>
                                  <option *ngFor="let b of businessCategory" [value]="b.idBusinessType"
                                    [ngValue]="b.idBusinessType">
                                    &nbsp;&nbsp;{{b.businessTypeName}}
                                  </option>
                                </select>
                                <div *ngIf="isNewSubmitted && f.businessCategory?.invalid" class="invalid">
                                  <div
                                    *ngIf="f.businessCategory?.errors.required && f.businessCategory.touched && f.businessCategory.invalid">
                                    &#65121; Kategori Bisnis harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="businessSubcategory" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="businessSubcategory" id="businessSubcategory">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Subkategori Bisnis</option>
                                  <option *ngFor="let b of businessSubcategory" [value]="b.id.businessSubtypeCode"
                                    [ngValue]="b.id.businessSubtypeCode">
                                    &nbsp;&nbsp;{{b.businessSubtypeName}}
                                  </option>
                                </select>
                                <div *ngIf="isNewSubmitted && f.businessSubcategory?.invalid" class="invalid">
                                  <div
                                    *ngIf="f.businessSubcategory?.errors.required && f.businessSubcategory.touched && f.businessSubcategory.invalid">
                                    &#65121; Subkategori Bisnis harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="picName" name="picName" formControlName="picName" class="form-control"
                                  placeholder="Nama PIC" type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  " />
                                <div *ngIf="isNewSubmitted && f.picName?.invalid" class="invalid">
                                  <div *ngIf="f.picName?.errors.required">
                                    &#65121; Nama PIC harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="picPosition" name="picPosition" formControlName="picPosition"
                                  class="form-control" placeholder="Posisi di Perusahaan" type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  " />
                                <div *ngIf="isNewSubmitted && f.picPosition?.invalid" class="invalid">
                                  <div *ngIf="f.picPosition?.errors.required">
                                    &#65121; Posisi di Perusahaan harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="email" name="email" formControlName="email" class="form-control"
                                  placeholder="Alamat Email" type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  " />
                                <div *ngIf="isNewSubmitted && f.email?.invalid" class="invalid">
                                  <div *ngIf="f.email?.errors.required">
                                    &#65121; Alamat Email harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="phoneNumber" name="phoneNumber" formControlName="phoneNumber"
                                  class="form-control" placeholder="Nomor Telepon" type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  " />
                                <div *ngIf="isNewSubmitted && f.phoneNumber?.invalid" class="invalid">
                                  <div *ngIf="f.phoneNumber?.errors.required">
                                    &#65121; Nomor Telepon harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <textarea #msg class="form-control height-fix" rows="5" id="comment"
                                  placeholder="Alamat Usaha" name="address" formControlName="address"
                                  style="background-color: #fafbfd;font-size: 14px;" required></textarea>

                                <div *ngIf="isNewSubmitted && f.address?.invalid" class="invalid">
                                  <div *ngIf="f.address?.errors.required">
                                    &#65121; Alamat Usaha harus diisi
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <input id="country" name="country" formControlName="country" class="form-control"
                                  type="text" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;


                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #E8EDF5;
                                    color:#BABCD1;
                                  " disabled />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="province" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="province" id="province"
                                  (change)="onChangeBusinessProvince($event.target.value)">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Provinsi</option>
                                  <option *ngFor="let b of province" [value]="b" [ngValue]="b">
                                    &nbsp;&nbsp;{{b}}
                                  </option>
                                </select>
                                <div *ngIf="isNewSubmitted && f.province?.invalid" class="invalid">
                                  <div *ngIf="f.province?.errors.required">
                                    &#65121; Provinsi harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="city" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="city" id="city" (change)="onChangeBusinessCity($event.target.value)"
                                  >
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Kota</option>
                                  <option *ngFor="let b of city" [value]="b" [ngValue]="b">
                                    &nbsp;&nbsp;{{b}}
                                  </option>
                                </select>
                                </div>

                                <div *ngIf="isNewSubmitted && f.city?.invalid" class="invalid">
                                  <div *ngIf="f.city?.errors.required && f.city.touched && f.city.invalid">
                                    &#65121; Kota harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group" style="margin: bottom 10px; position: relative;">
                                <div class="form-input-container" style="
                                    position: relative;
                                    margin-bottom: -8px;
                                    left: 0px;
                                    right: 0px;
                                    top: 0px;
                                    bottom: 0px;

                                    background: #fafbfd;
                                    border-radius: 4px;
                                  ">
                                  <select formControlName="district" style="
                                      left: 20px;
                                      right: 16px;
                                      top: 11px;
                                      bottom: 11px;

                                      font-style: normal;
                                      font-weight: normal;
                                      font-size: 14px;
                                      line-height: 20px;

                                      /* identical to box height, or 143% */
                                      display: flex;
                                      align-items: center;
                                      letter-spacing: 0.2px;
                                      background-color: #fafbfd;
                                      color: #a0a3bd;
                                      width: 100%;
                                      height: 35px;
                                      border: 1px solid #ced4da;
                                      background-clip: padding-box;
                                      border-radius: 4px;
                                    " name="district" id="district"
                                    (change)="onChangeBusinessDistrict($event.target.value)">
                                    <option value="" disabled selected hidden>&nbsp;&nbsp;Kecamatan</option>
                                    <option *ngFor="let d of district" [value]="d" [ngValue]="d">
                                      &nbsp;&nbsp;{{d}}
                                    </option>
                                  </select>
                                  <div *ngIf="isNewSubmitted && f.district?.invalid" class="invalid">
                                    <div *ngIf="f.district?.errors.required && f.district.touched && f.district.invalid">
                                      &#65121; Kecamatan harus diisi.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="subDistrict" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="subDistrict" id="subDistrict"
                                  (change)="onChangeBusinessSubDistrict($event.target.value)">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Kelurahan</option>
                                  <option *ngFor="let b of subDistrict" [value]="b" [ngValue]="b">
                                    &nbsp;&nbsp;{{b}}
                                  </option>
                                </select>
                                <div *ngIf="isNewSubmitted && f.subDistrict?.invalid" class="invalid">
                                  <div
                                    *ngIf="f.subDistrict?.errors.required && f.subDistrict.touched && f.subDistrict.invalid">
                                    &#65121; Kelurahan harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" style="margin: bottom 10px; position: relative;">
                              <div class="form-input-container" style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                ">
                                <select formControlName="postalCode" style="
                                    left: 20px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                    width: 100%;
                                    height: 35px;
                                    border: 1px solid #ced4da;
                                    background-clip: padding-box;
                                    border-radius: 4px;
                                  " name="postalCode" id="postalCode">
                                  <option value="" disabled selected hidden>&nbsp;&nbsp;Kode Pos</option>
                                  <option *ngFor="let b of postalCode" [value]="b" [ngValue]="b">
                                    &nbsp;&nbsp;{{b}}
                                  </option>
                                </select>
                                <div *ngIf="isNewSubmitted && f.postalCode?.invalid" class="invalid">
                                  <div *ngIf="f.postalCode?.errors.required">
                                    &#65121; Kode Pos harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <p class="tx-medium" style="
                                font-size: 12px;
                                color: #737b7d;
                                line-height: 1.42857143;
                                margin-bottom: none;
                                box-sizing: border-box;

                              ">
                              Dengan melanjutkan ke langkah berikutnya, Anda
                              menyetujui semua
                              <a class="terms-and-conditions-link" [routerLink]="['/syarat&ketentuan']" style="
                                  color: #3c64b1;
                                  text-decoration: none;

                                ">syarat &amp; ketentuan</a>
                              serta
                              <a class="terms-and-conditions-link" [routerLink]="['/kebijakan-privasi']" style="
                                  color: #3c64b1;
                                  text-decoration: none;

                                ">kebijakan privasi</a>
                              yang berlaku.
                            </p>
                          </div>
                          <div class="col-sm-6">
                            <div *ngIf="buttonSubmit">
                              <button type="submit" style="
                                  color: #fff;
                                  background-color: #3c64b1;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #3c64b1;

                                  /* Elevasi 3 */
                                  box-shadow: 4px 8px 24px rgba(0, 0, 0, 0.1);
                                  border-radius: 4px;
                                " [disabled]="newRegisterCustomerForm.invalid"
                                class="btn btn-block contained js-regist-check-2fa-flag">
                                Daftar Sekarang
                              </button>
                            </div>
                            <div *ngIf="buttonLoading">
                              <button class="btn btn-primary" disabled>
                                <span class="spinner-border spinner-border-sm"></span>
                                Loading..
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="row" style="
                            border-top: 1px solid #e8e8e8;
                            margin-left: 0px;
                          ">
                          <h6 style="margin-top: 26px;">
                            <p style="
                                position: absolute;
                                width: auto;
                                height: 24px;

                                font-style: normal;
                                font-weight: bold;
                                font-size: 18px;
                                line-height: 24px;
                                margin-left: -10px;
                                /* identical to box height, or 133% */
                                letter-spacing: 0.1px;

                                /* Light / Black */
                                color: #373f41;
                              ">
                              Sudah punya akun? Silahkan
                              <a class="terms-and-conditions-link"
                                href="https://idp.pepperi.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dpepperi.webapp.www.sukandaonelink.com%26redirect_uri%3Dhttps%253A%252F%252Fwww.sukandaonelink.com%252Fcallback.html%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520pepperi.webapp_api%2520pepperi.profile%2520pepperi.webapp_identity%2520pepperi.apint%26state%3D96853cac34694c198b349b260598baf4%26code_challenge%3D4dLrB1oaeKJ2grjpIm3JKUDDrcWVaug8v4NH_p9NgdY%26code_challenge_method%3DS256%26response_mode%3Dquery"
                                style="
                                  color: #3c64b1;
                                  text-decoration: none;

                                ">Login disini</a>
                            </p>
                          </h6>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div *ngIf="existing ==='belum' && tipe ==='Pribadi'">
                    <div>
                      <form class="tipePelangganPribadi">
                        <div class="row" style="
                            margin-top: 32px;
                          ">
                          <div class="col" style="
                              position: static;
                              left: calc(50% - 433px / 2 - 4px);
                              top: 8px;
                              bottom: 8px;
                              font-style: normal;
                              font-weight: normal;
                              font-size: 14px;
                              line-height: 22px;

                              /* identical to box height, or 157% */
                              letter-spacing: 0.3px;

                              /* Light / Gray dark */
                              color: #737b7d;
                              text-align: center;
                            ">
                            <p>
                              Untung melakukan pesanan silahkan melalui channel
                              berikut ini:
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-3"></div>
                          <div class="col-sm-3">
                            <a class="official-store" style="text-decoration: none;" href="https://linktr.ee/sukandadjaya">
                              <img class="img-fluid mx-auto d-block" title="login image" alt="login image" src="assets/img/official.png" />
                              <p style="
                                height: 18px;
                                left: 0px;
                                right: 0px;
                                top: calc(50% - 18px / 2);
                                margin-top: 20px;

                                font-style: normal;
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 18px;
                                /* identical to box height, or 129% */
                                align-items: center;
                                text-align: center;
                                letter-spacing: 0.3px;
                                color: #3c64b1;
                              ">
                                Belanja Sekarang
                              </p>
                            </a>
                          </div>
                          <div class="col-sm-3">
                            <a class="official-store" style="text-decoration: none;" [routerLink]="['/hubungi-kami']">
                            <img class="img-fluid mx-auto d-block" title="login image" alt="login image" src="assets/img/layanan.png" />
                            <p style="
                                height: 18px;
                                left: 0px;
                                right: 0px;
                                top: calc(50% - 18px / 2);
                                margin-top: 20px;

                                font-style: normal;
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 18px;
                                /* identical to box height, or 129% */
                                align-items: center;
                                text-align: center;
                                letter-spacing: 0.3px;
                                color: #3c64b1;
                              ">
                              Hubungi Sekarang
                            </p>
                            </a>
                          </div>
                          <div class="col-sm-3"></div>
                        </div>

                        <div class="row" style="
                            width: 708px;
                            border-top: 1px solid #e8e8e8;
                            margin-left: 0px;
                            margin-top: 43px;
                          ">
                          <h6 style="margin-top: 26px;">
                            <p style="
                                position: absolute;
                                width: auto;
                                height: 24px;

                                font-style: normal;
                                font-weight: bold;
                                font-size: 18px;
                                line-height: 24px;
                                margin-left: -10px;
                                /* identical to box height, or 133% */
                                letter-spacing: 0.1px;

                                /* Light / Black */
                                color: #373f41;
                              ">
                              Sudah punya akun? Silahkan
                              <a class="terms-and-conditions-link"
                                href="https://idp.pepperi.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dpepperi.webapp.www.sukandaonelink.com%26redirect_uri%3Dhttps%253A%252F%252Fwww.sukandaonelink.com%252Fcallback.html%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520pepperi.webapp_api%2520pepperi.profile%2520pepperi.webapp_identity%2520pepperi.apint%26state%3D96853cac34694c198b349b260598baf4%26code_challenge%3D4dLrB1oaeKJ2grjpIm3JKUDDrcWVaug8v4NH_p9NgdY%26code_challenge_method%3DS256%26response_mode%3Dquery"
                                style="
                                  color: #3c64b1;
                                  text-decoration: none;
                                ">Login disini</a>
                            </p>
                          </h6>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="yCmsComponent regist-left-content-component reorder-containers" style="order: 1;">
            <div class="banner__component simple-banner" style="width: 100%; height: auto;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
